"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _containers = require("../../../containers");
var _containers2 = require("../containers");
var _components = require("../components");
var _invitationsDeprecated = require("../../invitations-deprecated");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
const SignUpView = props => {
  return /*#__PURE__*/_react.default.createElement(_containers.MapQueryParamsToProps, _extends({}, props, {
    queryName: "code",
    propName: "id"
  }), /*#__PURE__*/_react.default.createElement(_containers.BaseShow, {
    entity: {
      singular: "invitation",
      plural: "invitations"
    },
    actions: _invitationsDeprecated.actions
  }, /*#__PURE__*/_react.default.createElement(_containers2.ShowMyOptins, null, /*#__PURE__*/_react.default.createElement(_containers2.SignUp, null, /*#__PURE__*/_react.default.createElement(_components.SignUpManager, props)))));
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(SignUpView);
module.exports = exports.default;